// @flow

import React, { useCallback, useRef, useState } from "react";
import { Maybe } from "ramda-fantasy";

import "./metodologia.css";

const Metodologia = () => {
  // Vamos esconder o iframe enquanto removemos o header, senão o usuário
  // pode ver o header por alguns mile segundos.
  const [visible, setVisible] = useState(false);

  const iframeRef = useRef(null);

  const removeHeader = useCallback(() => {
    if (iframeRef.current) {
      const topo = Maybe(iframeRef.current)
        .chain(iframe => Maybe(iframe.contentDocument))
        .chain(contentDocument => Maybe(contentDocument.getElementById("topo")))
        .getOrElse(null);

      if (topo && topo.parentElement) topo.parentElement.removeChild(topo);
    }
    setVisible(true);
  }, []);

  return (
    <iframe
      className="Metodologia__iframe"
      src={process.env.REACT_APP_METODOLOGIA_PATH || "/metodologia.html"}
      title="Metodologia"
      onLoad={removeHeader}
      style={{ visibility: visible ? "visible" : "hidden" }}
      ref={iframeRef}
    />
  );
};

export default Metodologia;
